'use client'
import dynamic from 'next/dynamic'
import React, { useState, useEffect } from 'react'
// import ContactCardSent from '@components/ContactCardSent'
import { FaUser } from 'react-icons/fa'
import { MdOutlinePhoneIphone, MdEmail } from 'react-icons/md'
import { AiFillWechat } from 'react-icons/ai'
import { FaLine, FaWhatsappSquare, FaPhoneSquareAlt } from 'react-icons/fa'
import { RiArrowDropDownLine } from 'react-icons/ri'
import { useSession } from 'next-auth/react'
import tailwindConfig from '@tailwind.config'
import { Combobox, Listbox } from "@headlessui/react"
import { countryCodes } from '@constants/countryCodes'
import { preferredContact } from '@constants/preferredContact';
import Image from 'next/image'
import Link from 'next/link'

const ContactProjectCardSent = dynamic(() => import('@components/ContactProjectCardSent'), {
    ssr: false,
})


const ContactCardProject = ({ project, agent, dictionary, lang }) => {
    // console.log(agent)
    const { data: session } = useSession()

    const [userId, setUserId] = useState(null)
    const [contact, setContact] = useState(preferredContact[lang][0])
    const [phone, setPhone] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [line, setLine] = useState('')
    const [wechat, setWechat] = useState('')
    const [message, setMessage] = useState(`${dictionary.messagePromtProject}`)
    const [hasEnquiry, setHasEnquiry] = useState(false)
    const [selectedCountry, setSelectedCountry] = useState(countryCodes[0].code)
    const [query, setQuery] = useState('')

    const filteredCountries =
        query === ''
            ? countryCodes
            : countryCodes.filter((country) => {
                return country.country.toLowerCase().includes(query.toLowerCase()) || country.code.toLowerCase().includes(query.toLowerCase())
            })

    useEffect(() => {
        const setUserData = () => {
            if (session?.user) {
                // console.log(session?.user)
                setUserId(session?.user.id)
                setName(session?.user.name)
                setPhone(session?.user.phone)
                setSelectedCountry(session?.user.phonePrefix || countryCodes[0].code)
                setEmail(session?.user.email)
                setHasEnquiry(project.enquiry)
            }
        }
        setUserData()
    }, [session])

    const handleForm = async (e) => {
        e.preventDefault()
        const { sendProjectContactForm } = await import('@services/sendProjectContactForm')
        await sendProjectContactForm(userId, name, selectedCountry, phone, email, message, project.id, contact, line, wechat)
        setHasEnquiry(true)
    }

    const selectTextOnClick = (e) => {
        e.target.select();
    };

    // const agent = {
    //     agentName: 'Uncle Agent',
    //     email: 'uncle@agent.com',
    //     line: 'line',
    //     whatsapp: 'whatsapp',
    //     phone: 'phone',
    // }

    return (
        <>
            {!hasEnquiry ? (
                <div className='w-full flex flex-col rounded-md border-[1px] p-4 text-maincolor bg-light'>
                    <div className='sm:block hidden'>
                        <h2 className='text-center font-semibold mb-4'>{dictionary.contactMeNow}</h2>
                        <div className='w-full flex flex-row'>
                            <div className='relative  w-[100px] h-[100px] aspect-[4/3] border-[1px] border-third rounded-md overflow-hidden'>
                                <Image
                                    className='object-contain cursor-pointer'
                                    // src={agent.cover}
                                    src={`/images/blogthumbnail.jpg`}
                                    // width={imageWidth}
                                    // height={imageHeight}
                                    fill={true}
                                    // alt={project.slug}
                                />
                            </div>
                            <div className='flex flex-col justify-between pl-2'>
                                <div className='flex flex-col h-full justify-evenly items-center'>
                                    <span className='text-maincolor'>{agent.agentName}</span>
                                    <div className='w-full justify-between sm:justify-start items-center flex flex-row'>
                                        {agent.agentContact && (
                                            <Link href={agent.agentContact} className='mr-2' target="_blank">
                                                <MdOutlinePhoneIphone
                                                    color={'#C62121'}
                                                    size={26}
                                                    className=''
                                                />
                                            </Link>
                                        )}
                                        {agent.agentLine && (
                                            <Link href={agent.agentLine} className='mr-2' target="_blank">
                                                <FaLine
                                                    color={'#32CD32'}
                                                    size={26}
                                                    className=''
                                                />
                                            </Link>
                                        )}
                                        {agent.agentWhatsapp && (
                                            <Link href={agent.agentWhatsapp} className='mr-2' target="_blank">
                                                <FaWhatsappSquare
                                                    color={'#25D366'}
                                                    size={26}
                                                    className=''
                                                />
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='mt-2'>
                            <span className='text-maincolor'>{agent.agentEmail}</span>
                        </div>
                    </div>
                    <div className='w-full sm:flex hidden items-center justify-center my-4'>
                        <span className='border-[1px] border-forth w-full'></span>
                        <span className='text-sm text-maincolor mx-2'>{dictionary.or}</span>
                        <span className='border-[1px] border-forth w-full'></span>
                    </div>
                    <h2 className='text-center font-semibold'>{dictionary.requestDetails}</h2>
                        <form onSubmit={handleForm}>
                            <label className='text-secondary'>{dictionary.name}:</label>
                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 mb-2'>
                                <FaUser
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                    size={26}
                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                />
                                <input
                                    className='w-full border-none py-2 pl-10 leading-5 text-gray-900 focus:ring-0'
                                    placeholder={dictionary.name}
                                    type='text'
                                    name='name'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <label className='text-secondary'>{dictionary.preferredContact}</label>
                            <Listbox value={contact} onChange={setContact}>
                                <div className='z-1 relative w-full cursor-default rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 mb-2'>
                                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left focus:shadow-md focus:outline-none" aria-label="Phone Dropdown">
                                        <span className="block truncate">{contact.name}</span>
                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <RiArrowDropDownLine
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={26}
                                            />
                                        </span>
                                    </Listbox.Button>
                                    <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 ring-1 ring-black ring-opacity-5 focus:outline-none z-50" aria-label="Select Preferred Contact Method">
                                        {preferredContact[lang].map((cont, contIdx) => (
                                            <Listbox.Option
                                                key={contIdx}
                                                className={({ active }) =>
                                                    `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                    }`
                                                }
                                                value={cont}
                                                aria-label={cont}
                                            >
                                                {({ selected }) => (
                                                    <>
                                                        <span
                                                            className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                }`}
                                                        >
                                                            {cont.name}
                                                        </span>
                                                        {selected ? (
                                                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                                                            </span>
                                                        ) : null}
                                                    </>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                </div>
                            </Listbox>
                            {(contact.value == 'phone' || contact.value == 'whatsapp' || contact.value == 'viber') && (
                                <>
                                    <label className='text-secondary'>{dictionary.phone}</label>
                                    <div className='flex flex-row w-full'>
                                        {/* <CountryCode className="w-1/4" /> */}
                                        <Combobox className="w-1/4"
                                            value={selectedCountry}
                                            onChange={setSelectedCountry}
                                        >
                                            <div className="relative w-full">
                                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 mb-2'>
                                                    <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                    <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                        <RiArrowDropDownLine
                                                            color={tailwindConfig.theme.extend.colors.secondary}
                                                            size={26}
                                                        />
                                                    </Combobox.Button>
                                                </div>
                                                <Combobox.Options
                                                    as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                    className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto rounded-md py-1'
                                                    aria-label="Country Code Select"
                                                >
                                                    {filteredCountries.map((country) => (
                                                        <Combobox.Option
                                                            key={country.id}
                                                            value={country.code}
                                                            className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                        >
                                                            {country.code} {country.country}
                                                        </Combobox.Option>
                                                    ))}
                                                </Combobox.Options>
                                            </div>
                                        </Combobox>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 mb-2'>
                                            <MdOutlinePhoneIphone
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={26}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 leading-5 text-gray-900 focus:ring-0'
                                                placeholder={`${dictionary.phone}`}
                                                required
                                                type='text'
                                                name='phone'
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {(contact.value == 'line') && (
                                <>
                                    <label className='text-secondary'>{dictionary.line}:</label>
                                    <div className='w-full py-1'>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 mb-2'>
                                            <FaLine
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={26}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.linePlaceholder}
                                                type='line'
                                                name='line'
                                                value={line}
                                                onChange={(e) => setLine(e.target.value)}
                                                required
                                                aria-label="LINE ID Input"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {(contact.value == 'wechat') && (
                                <>
                                    <label className='text-secondary'>{dictionary.wechat}</label>
                                    <div className='w-full py-1'>
                                        <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 mb-2'>
                                            <AiFillWechat
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                size={26}
                                                className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                            />
                                            <input
                                                className='w-full border-none py-2 pl-10 leading-5 text-gray-900 focus:ring-0'
                                                placeholder={dictionary.wechatPlaceholder}
                                                type='wechat'
                                                name='wechat'
                                                value={wechat}
                                                onChange={(e) => setWechat(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            <label className='text-secondary'>{dictionary.email}</label>
                            <div className='w-full'>
                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 mb-2'>
                                    <MdEmail
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                        size={26}
                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                    />
                                    <input
                                        className='w-full border-none py-2 pl-10 leading-5 text-gray-900 focus:ring-0'
                                        placeholder={`${dictionary.email}`}
                                        type='email'
                                        name='email'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <label className='text-secondary'>{dictionary.message}</label>
                            <div className='w-full py-1'>
                                <textarea
                                    className='w-full border-[1px] border-forth text-secondary rounded-md p-2'
                                    placeholder='Please enter your question on request'
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    rows={3}
                                    required
                                />
                            </div>
                            <button className='w-full p-2 bg-third hover:bg-maincolor delay-300 text-light font-bold rounded-md shadow-[0_8px_30px_rgb(0,0,0,0.12)]' type='submit'>{dictionary.send}</button>
                        </form>

                </div>) : (
                <ContactProjectCardSent enquiryId={project.enquiryId} projectId={project.id} email={email} dictionary={dictionary} />
            )}
        </>
    )
}

export default ContactCardProject